import { Header, Loader, Panel, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { getDisplayPriceFromFuelsList, noop } from '../../../lib/utils';
import AddressProps from '../../prop-types/address';
import GenericStationListItem from '../GenericStationListItem';
import styles from './NearbyStationsList.module.css';

const cx = classnames.bind(styles);

export default function NearbyStationsList({
  displayCount,
  fetchFuels,
  fetchNearbyStationsById,
  isFetching,
  nearbyStationIds,
  stationId,
  stations,
  error,
}) {
  useEffect(() => {
    if (nearbyStationIds) {
      // We're getting a new batch of nearby stations, so fetch their fuels
      fetchFuels(nearbyStationIds);
    }
  }, [fetchFuels, nearbyStationIds]);

  useEffect(() => {
    if (stationId && !isFetching && !error && !nearbyStationIds) {
      fetchNearbyStationsById(stationId);
    }
  }, [fetchNearbyStationsById, isFetching, error, stationId, nearbyStationIds]);

  let stationContent = (
    <Loader />
  );

  if (!isFetching && !error) {
    stationContent = nearbyStationIds?.length && stations?.length
      ? stations.slice(0, displayCount).map(station => (
        <GenericStationListItem
          displayPrice={getDisplayPriceFromFuelsList(station.displayFuel.regular_gas && [station.displayFuel.regular_gas])}
          fuelType={station.fuelType}
          key={station.id}
          small
          station={station}
        />
      ))
      : (
        <Text as="p">
          No nearby stations found
        </Text>
      );
  }

  return (
    <div className={cx('container')}>
      <Header as="h3" className={cx('nearbyStationsHeader')}>
        Nearby Stations
      </Header>

      <Panel bordered color="white" padded={!nearbyStationIds?.length} rounded>
        {error
          ? (
            <Text color="orange">
              {error}
            </Text>
          )
          : stationContent
        }
      </Panel>
    </div>
  );
}

NearbyStationsList.propTypes = {
  displayCount: PropTypes.number,
  fetchFuels: PropTypes.func,
  fetchNearbyStationsById: PropTypes.func,
  isFetching: PropTypes.bool,
  nearbyStationIds: PropTypes.arrayOf(PropTypes.number),
  stations: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    distance: PropTypes.number,
    price: PropTypes.number,
    address: AddressProps.isRequired,
  })),
  stationId: PropTypes.string.isRequired,
  error: PropTypes.string,
};

NearbyStationsList.defaultProps = {
  displayCount: 5,
  fetchFuels: noop,
  fetchNearbyStationsById: noop,
  isFetching: false,
  nearbyStationIds: undefined,
  stations: undefined,
  error: undefined,
};
